export const api_version = process.env.REACT_APP_VERSION

export const getAmplitudeKey = (partnerId) => {
  switch (+partnerId) {
    case 1:
      return process.env.REACT_APP_AMPLITUDE_KEY_WW
    case 19:
      return process.env.REACT_APP_AMPLITUDE_KEY_NOOM
    case 20:
      return process.env.REACT_APP_AMPLITUDE_KEY_NOOM_VIBE
    case 21:
      return process.env.REACT_APP_AMPLITUDE_KEY_REVIVE
    default:
      return ''
  }
}

export const BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY

export const getGTMID = (partnerId) => {
  switch (+partnerId) {
    case 1:
      return process.env.REACT_APP_GTM_ID_WW
    case 19:
      return process.env.REACT_APP_GTM_ID_NOOM
    case 20:
      return process.env.REACT_APP_GTM_ID_NOOM_VIBE
    default:
      return ''
  }
}
